export default "__VITE_ASSET__CwLDU38F__"